// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"column_listContainer__tYq91","header":"column_header__bCSor","footerLinks":"column_footerLinks__HKBfO"};